import React from 'react';

/**
 * Fundo ambiente da Workspace — CSS-only, zero canvas, zero RAF.
 *
 * Reatividade via filter: hue-rotate + brightness na camada base.
 * - idle       → azul profundo estático
 * - thinking   → azul → ciano suave → azul (lento, 3s)
 * - responding → azul → ciano vivo  → azul (rápido, 2.2s)
 * - processing / streaming (voz) → azul → violeta suave → azul
 */

function buildStars(n) {
  const out = [];
  for (let i = 0; i < n; i++) {
    const t = (i * 137.508) % 100;
    const l = (i * 97.3 + 13) % 100;
    out.push({
      id: i,
      top:  35 + (t % 58),
      left:  2 + (l % 96),
      r:    0.5 + (i % 3) * 0.55,
      op:   0.08 + (i % 5) * 0.038,
      dur:  2.8 + (i % 7) * 0.5,
    });
  }
  return out;
}

const STARS = buildStars(24);

const KF = `
@keyframes athGlowThink {
  0%, 100% { filter: hue-rotate(0deg)   brightness(1)   saturate(1);   }
  50%       { filter: hue-rotate(-45deg) brightness(1.7) saturate(1.3); }
}
@keyframes athGlowRespond {
  0%, 100% { filter: hue-rotate(0deg)   brightness(1)   saturate(1);   }
  50%       { filter: hue-rotate(-25deg) brightness(2.1) saturate(1.5); }
}
@keyframes athGlowComplex {
  0%, 100% { filter: hue-rotate(0deg)  brightness(1)   saturate(1);   }
  50%       { filter: hue-rotate(50deg) brightness(1.4) saturate(1.2); }
}
@keyframes athBgStar {
  0%,100% { opacity: var(--s-op); }
  50%      { opacity: calc(var(--s-op) * 2.4); }
}
`;

const BLUE_BG = [
  'radial-gradient(ellipse 85% 52% at 50% 108%, rgba(16,68,195,0.88) 0%, rgba(8,36,120,0.48) 30%, transparent 60%)',
  'radial-gradient(ellipse 130% 38% at 50% 104%, rgba(22,52,165,0.38) 0%, transparent 52%)',
  'radial-gradient(ellipse 65% 28% at 50% 75%,  rgba(6,24,80,0.20)   0%, transparent 55%)',
].join(',');

export function AthenaWorkspaceBg({ state = 'idle' }) {
  const isThinking   = state === 'thinking';
  const isResponding = state === 'responding';
  const isComplex    = state === 'processing' || state === 'streaming';

  return (
    <div style={{
      position: 'fixed', inset: 0, zIndex: -1,
      pointerEvents: 'none', overflow: 'hidden',
      background: '#010810',
    }}>
      <style>{KF}</style>

      {/* Glow base — muda cor via hue-rotate quando thinking/responding */}
      <div className="athena-bg-layer" style={{
        position: 'absolute', inset: 0,
        background: BLUE_BG,
        transition: 'filter 0.6s ease',
        animation: isThinking   ? 'athGlowThink   3s   ease-in-out infinite'
                 : isResponding ? 'athGlowRespond  2.2s ease-in-out infinite'
                 : isComplex    ? 'athGlowComplex  2.8s ease-in-out infinite'
                 : 'none',
      }}/>

      {/* Estrelinhas estáticas */}
      {STARS.map(s => (
        <div key={s.id} className="athena-bg-star" style={{
          position: 'absolute',
          top: `${s.top}%`, left: `${s.left}%`,
          width: s.r * 2, height: s.r * 2,
          borderRadius: '50%', background: '#7cb8ff',
          '--s-op': s.op, opacity: s.op,
          animation: `athBgStar ${s.dur}s ease-in-out ${s.dur * 0.4}s infinite`,
        }}/>
      ))}
    </div>
  );
}
